"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

var _Address = require("./Address");

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdditionalAddressesModel = function (_Observer) {
    _inherits(AdditionalAddressesModel, _Observer);

    /**
     * Liste von zusätzlichen Adressen
     * @type {Array} von zusätzlichen Adressen
     
    AdditionalAddresses*/

    function AdditionalAddressesModel(observers, id, request) {
        _classCallCheck(this, AdditionalAddressesModel);

        var _this = _possibleConstructorReturn(this, (AdditionalAddressesModel.__proto__ || Object.getPrototypeOf(AdditionalAddressesModel)).call(this, observers, id, request));

        _this.AdditionalAddresses = [];

        _this.Address = new _Address2.default();

        _this.AddressTypes = [];
        return _this;
    }

    _createClass(AdditionalAddressesModel, [{
        key: "GetAdditionalAddressesByCustomerId",
        value: function GetAdditionalAddressesByCustomerId(customerId) {
            var me = this;
            this.request.setRequest("/Customers/" + customerId + "/Addresses");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.AdditionalAddresses = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "AdditionalAddresses";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "UpdateAdditionalAddress",
        value: function UpdateAdditionalAddress() {
            var me = this;
            this.request.setRequest("/Addresses");
            this.request.setData(JSON.stringify(this.Address));
            this.request.setType("PUT");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.Address = data.Data;
                    }
                }
                var id = me.Id ? me.Id : "AddressPUT";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "GetAdditionalAddressTypes",
        value: function GetAdditionalAddressTypes() {
            var me = this;
            this.request.setRequest("/Addresses");
            this.request.setType("GET");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.AddressTypes = data.Data;
                    }
                }
                var id = me.Id ? me.Id : "AddressTypes";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "SetNewAdditionalAddressByCustomerId",
        value: function SetNewAdditionalAddressByCustomerId(customerId) {
            var me = this;
            this.request.setRequest("/Customers/" + customerId + "/Addresses");
            this.request.setData(JSON.stringify(this.Address));
            this.request.setType("POST");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.Address = data.Data;
                    }
                }
                var id = me.Id ? me.Id : "NewAdditionalAddress";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return AdditionalAddressesModel;
}(_Observer3.default);

exports.default = AdditionalAddressesModel;